import cn from 'classnames';

interface SliderArrowsProps {
  prevRef?: React.MutableRefObject<HTMLDivElement>;
  nextRef?: React.MutableRefObject<HTMLDivElement>;
  theme: 'dark' | 'light';
  index: number;
  // Swiper shows and hides the arrows itself through the refs. Before it has
  // loaded, the static hero uses these to show the next arrow on the first slide.
  showNext?: boolean;
  onNext?: () => void;
}

const Arrows = ({
  prevRef,
  nextRef,
  theme,
  index,
  showNext = false,
  onNext,
}: SliderArrowsProps) => {
  const containerCss = 'group absolute z-40 h-full w-0 cursor-pointer lg:w-20';
  const innerCss =
    'h-4 w-4 transition-all duration-200 ease-in-out group-hover:h-5 group-hover:w-5';

  const generateArrowsColor = () => {
    if (index === 0) {
      return 'white';
    }

    if (theme === 'light') {
      return '#1F2323';
    }

    return 'white';
  };

  return (
    <div className="hidden lg:block">
      <div ref={prevRef} className={cn('left-0 hidden', containerCss)}>
        <div className="flex h-full items-center justify-center">
          <div className="rounded-full bg-transparent p-3 backdrop-blur-xl">
            <div className={innerCss}>
              <svg viewBox="0 0 100 100">
                <path
                  d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
                  transform="translate(0, 0) rotate(0)"
                  fill={generateArrowsColor()}
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        ref={nextRef}
        className={cn('right-0', containerCss, { hidden: !showNext })}
        onClick={onNext}
      >
        <div className="flex h-full items-center justify-center">
          <div className="rounded-full bg-transparent p-3 backdrop-blur-xl">
            <div className={innerCss}>
              <svg viewBox="0 0 100 100">
                <path
                  d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
                  transform="translate(100, 100) rotate(180)"
                  fill={generateArrowsColor()}
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Arrows;
